import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { InfoMenuModalComponent } from 'src/app/modals/info-menu-modal/info-menu-modal.component';

@Component({
  selector: 'app-card-menu',
  templateUrl: './card-menu.component.html',
  styleUrls: ['./card-menu.component.scss'],
})
export class CardMenuComponent implements OnInit {
  @Input() menu: any;

  constructor(public modal: MatDialog) {}

  ngOnInit(): void {}

  openInfo() {
    const dialogRef = this.modal.open(InfoMenuModalComponent, {
      data: { idMenu: this.menu.id },
      disableClose: true,
      width: '100vw',
    });

    dialogRef.afterClosed().subscribe(async (result: any) => {
      if (result) {
      }
    });
  }
}
